module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": _vm.multiple,
      "placeholder": "输入账号、昵称进行搜索",
      "filterable": "",
      "size": "mini",
      "clearable": "",
      "loading": _vm.loading
    },
    model: {
      value: (_vm.user_id),
      callback: function($$v) {
        _vm.user_id = $$v
      },
      expression: "user_id"
    }
  }, _vm._l((_vm.user_data), function(item) {
    return _c('el-option', {
      key: item[_vm.key_type],
      attrs: {
        "label": item.username + '(' + item.nick + ')',
        "value": item[_vm.key_type]
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-222719cb","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/user/user_select.vue
// module id = ILtu
// module chunks = 81